export class Request {
    Id?: number;
    SecondName: string = "";
    FirstName: string = "";
    MiddleName: string = "";
    Period: Date = new Date(new Date());
    Birthday: Date;
    Count: number = 1;
    Email: string = "";
    Region: string = "";
    City: string = "";
    Street: string = "";
    House: string = "";
    Flat: string = "";
    zip_code: string = "";
    TypeDocument: number = 1;
    IssuedBy: string = "";
    RequestTypeId: number = 0;
    WhenIssued: Date;
    SerialPassport: string = "";
    NumberPassport: string = "";
    NumberINN: string = "";
    kladr: string = "";
    IsAuth: boolean = false;
    userInfo: any = {};
    gender: string = "-1";
    filesNames: string[] = [];
}